import { NoBlending, ShaderMaterial, Uniform } from "three";

import vertexShader from "./glsl/Common.vert";
import fragmentShaderSource from "./glsl/TetrahedralInterpolation.frag";
import blendFunctions from "./glsl/BlendFunctions.frag";
import blendMode from "./glsl/BlendMode.frag";

/**
 * A simple copy shader material.
 */

export class TetrahedralInterpolationMaterial extends ShaderMaterial {

    /**
     * Constructs a new ACES material.
     */

    constructor(curveTexture) {
        let fragmentShader = fragmentShaderSource.replace("BLEND_FUNCTIONS;", blendFunctions);
        fragmentShader = fragmentShader.replace("BLEND_MODE;", blendMode);

        super({
            name: "TetrahedralInterpolationMaterial",
            uniforms: {
                inputBuffer: new Uniform(null),
                opacity: new Uniform(1.0),
                blendID: new Uniform(0),
                r_R: new Uniform(0),
                r_G: new Uniform(0),
                r_B: new Uniform(0),
                g_R: new Uniform(0),
                g_G: new Uniform(0),
                g_B: new Uniform(0),
                b_R: new Uniform(0),
                b_G: new Uniform(0),
                b_B: new Uniform(0),
                c_R: new Uniform(0),
                c_G: new Uniform(0),
                c_B: new Uniform(0),
                m_R: new Uniform(0),
                m_G: new Uniform(0),
                m_B: new Uniform(0),
                y_R: new Uniform(0),
                y_G: new Uniform(0),
                y_B: new Uniform(0),
                w_R: new Uniform(0),
                w_G: new Uniform(0),
                w_B: new Uniform(0),
            },
            blending: NoBlending,
            depthWrite: false,
            depthTest: false,
            fragmentShader,
            vertexShader
        });

        /** @ignore */
        this.toneMapped = false;

    }


    /**
     * The input buffer.
     *
     * @type {Texture}
     */

    set inputBuffer(value) {

        this.uniforms.inputBuffer.value = value;

    }

    /**
     * Sets the input buffer.
     *
     * @deprecated Use inputBuffer instead.
     * @param {Number} value - The buffer.
     */

    setInputBuffer(value) {

        this.uniforms.inputBuffer.value = value;

    }

    /**
     * Returns the opacity.
     *
     * @deprecated Use opacity instead.
     * @return {Number} The opacity.
     */

    getOpacity(value) {

        return this.uniforms.opacity.value;

    }

    /**
     * Sets the opacity.
     *
     * @deprecated Use opacity instead.
     * @param {Number} value - The opacity.
     */

    setOpacity(value) {

        this.uniforms.opacity.value = value;

    }

}
